import { DisplayElementModel } from './display-element.model';
import { ImageHelper } from '../helpers/image.helper';
import { ImageStyleModel } from './image-style.model';
import { ImageSettingsModel } from './image-settings.model';
import { ImageDisplayElementApiModel } from '../../../api/pagebuilder/models/image-display-element-api.model';
import { FileUploadModel } from '@Common/Forms/models/file-upload.model';

export class ImageDisplayElementModel extends DisplayElementModel {
    declare styles: ImageStyleModel;
    declare settings: ImageSettingsModel;
    placeholderHeight: number = 120;

    image: FileUploadModel;
    oldUrl: string;
    width: number;

    constructor(
        apiModel: ImageDisplayElementApiModel
    ) {
        super();
        this.isBoundToGlobalStyles = true;

        if (apiModel) {
            this.image = {
                url: apiModel.url,
                altText: apiModel.altText
            };
            this.styles = new ImageStyleModel(apiModel.styles);
            this.settings = new ImageSettingsModel(apiModel);
            this.width = this.styles?.originalWidth || apiModel?.width;
        } else {
            this.styles = new ImageStyleModel();
            this.settings = new ImageSettingsModel();
        }
    }

    canRender(): boolean {
        return !!this.image?.url;
    }

    toApi(): ImageDisplayElementApiModel {
        const linkApi = this.settings?.link?.toApi();

        const apiModel = Object.assign(
            {},
            this.settings,
            <ImageDisplayElementApiModel> {
                url: this.image?.url,
                altText: this.image?.altText,
                styles: JSON.parse(JSON.stringify(this.styles)),
                width: this.width,
            },
            { link: linkApi }
        );

        return apiModel;
    }

    clone(): ImageDisplayElementModel {
        const clone = new ImageDisplayElementModel(this.toApi()) as this;
        clone.displayType = this.displayType;

        return clone;
    }

    async onUpdate(): Promise<boolean> {
        let changes = false;
        if (this.image?.url !== this.oldUrl) {
            changes = true;

            if (this.image) {
                try {
                    const width = await ImageHelper.getImageWidth(this.image.url);
                    if (this.width && this.width >= width) {
                        this.width = width as number;
                    }
                } catch (e) {
                    // Probably couldn't fetch the image
                    if (!this.width) {
                        this.width = 640;
                    }
                }
            } else {
                if (!this.width) {
                    this.width = 640;
                }
            }
        }
        this.oldUrl = this.image.url;

        return changes;
    }

    isEqual(other: ImageDisplayElementModel): boolean {
        if (this.image?.url !== other.image?.url) {
            return false;
        }
        if (this.image?.altText !== other.image?.altText) {
            return false;
        }
        if (!this.styles.equals(other.styles)) {
            return false;
        }
        if (JSON.stringify(this.settings) !== JSON.stringify(other.settings)) {
            return false;
        }
        return true;
    }
}
